import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../redux/store';
import { revokeMyApiKey } from "../../../redux/actions/apiKeys.actions";
import { ModalProps } from "../../../components/common/Interfaces/Modals";
import KeyActionModal from "../../../components/common/KeyActionModal";
import { clearError } from "../../../redux/reducers/myApiKeys.reducer";

const RevokeMyKeyModal: React.FC<ModalProps> = ({ open, setOpen, object }) => {
  const dispatch = useDispatch<AppDispatch>();
  const { error, loading } = useSelector((state: RootState) => state.myApiKeys);

  return (
    <KeyActionModal
      open={open}
      setOpen={setOpen}
      title={`Revoke API key for ${object?.name ?? object?.spaGuid}?`}
      body="Anything using this key will stop working immediately."
      actionLabel="Revoke"
      destructive
      loadingLabel="Revoking..."
      successMessage="API key revoked."
      loading={loading}
      error={error}
      clearError={() => dispatch(clearError())}
      onConfirm={async () => {
        await dispatch(revokeMyApiKey({ spaGuid: object?.spaGuid }));
      }}
    />
  );
};

export default RevokeMyKeyModal;
